import { render, staticRenderFns } from "./KnowDetail.vue?vue&type=template&id=449ca3ae&scoped=true&"
import script from "./KnowDetail.vue?vue&type=script&lang=js&"
export * from "./KnowDetail.vue?vue&type=script&lang=js&"
import style0 from "./KnowDetail.vue?vue&type=style&index=0&id=449ca3ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449ca3ae",
  null
  
)

export default component.exports